import React from 'react';

import { DLink } from '@dnse/ui';

interface Props {
  items: BreadcrumbItem[];
  color?: string;
}

export type BreadcrumbItem = {
  label: string;
  to?: string;
  isNativeLink?: boolean;
};

export const BreadCrumbs: React.FC<Props> = ({
  items,
  color = 'text-gray-300'
}) => {
  const breadcrumbs = insertSeparators(items, '/', color);
  return (
    <nav aria-label="breadcrumbs" className="mt-[12px]">
      <ol className="breadcrumbs-ol flex flex-wrap items-center">
        {breadcrumbs.map((item, index) => {
          if (item.label) {
            if (item.isNativeLink) {
              return (
                <li key={index}>
                  <a
                    key={item.to}
                    href={item.to || '/'}
                    className="underline text-sm md:text-base"
                  >
                    {item.label}
                  </a>
                </li>
              );
            }
            return (
              <li key={index}>
                <DLink
                  href={item.to || '/'}
                  className={`${color}`}
                  // style={{ textDecoration: 'underline' }}
                >
                  <p className="text-sm">{item.label}</p>
                </DLink>
              </li>
            );
          }
          return item;
        })}
      </ol>
    </nav>
  );
};

function insertSeparators(
  items,
  separator = '/',
  separatorColor = 'common.white'
) {
  const length = items.length - 1;
  return items.reduce((acc, current, index) => {
    if (index < length) {
      // eslint-disable-next-line no-param-reassign
      acc = acc.concat(
        current,
        <li
          key={`separator-${index}`}
          aria-hidden
          className={`flex mx-1 ${separatorColor} select-none`}
        >
          {separator}
        </li>
      );
    } else {
      acc.push(current);
    }

    return acc;
  }, []);
}
